var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2596)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.799,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0833,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.492,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4214,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.1371,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0661,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7107,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.428,
    x2: 439.82,
    y2: 8.64464,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 44,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.1421,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3553,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4974,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.716 112.389C111.942 112.389 110.286 112.097 108.75 111.513C107.235 110.907 105.905 110.063 104.758 108.981C103.611 107.9 102.713 106.634 102.064 105.184C101.436 103.713 101.123 102.122 101.123 100.413C101.123 98.6817 101.436 97.0913 102.064 95.6416C102.713 94.1918 103.6 92.9368 104.725 91.8766C105.872 90.8163 107.203 89.9941 108.718 89.4098C110.232 88.804 111.877 88.501 113.651 88.501C115.447 88.501 117.091 88.7823 118.585 89.3449C120.078 89.9075 121.376 90.6865 122.479 91.6818L118.163 96.0311C117.643 95.4685 117.005 95.0249 116.248 94.7003C115.512 94.3758 114.646 94.2135 113.651 94.2135C112.785 94.2135 111.985 94.3541 111.249 94.6354C110.535 94.9167 109.918 95.3278 109.399 95.8688C108.88 96.4097 108.469 97.0697 108.166 97.8487C107.884 98.606 107.744 99.4607 107.744 100.413C107.744 101.387 107.884 102.263 108.166 103.042C108.469 103.799 108.88 104.448 109.399 104.989C109.918 105.53 110.535 105.952 111.249 106.255C111.985 106.536 112.785 106.677 113.651 106.677C114.625 106.677 115.49 106.526 116.248 106.223C117.027 105.92 117.697 105.476 118.26 104.892L122.609 109.241C121.462 110.236 120.175 111.015 118.747 111.578C117.319 112.119 115.642 112.389 113.716 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.862 112.389C133.828 112.389 132.054 111.978 130.539 111.156C129.024 110.312 127.845 109.155 127.001 107.683C126.157 106.212 125.735 104.524 125.735 102.62V88.8905H132.227V103.204C132.227 103.94 132.389 104.567 132.714 105.087C133.038 105.606 133.471 106.006 134.012 106.288C134.574 106.547 135.191 106.677 135.862 106.677C136.554 106.677 137.16 106.547 137.679 106.288C138.22 106.006 138.642 105.617 138.945 105.119C139.248 104.6 139.4 103.972 139.4 103.237V88.8905H145.924V102.652C145.924 104.556 145.502 106.244 144.658 107.716C143.835 109.165 142.667 110.312 141.152 111.156C139.659 111.978 137.896 112.389 135.862 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.837 112.389C155.868 112.389 154.148 112.108 152.676 111.546C151.227 110.961 149.885 110.042 148.652 108.787L152.709 104.73C153.553 105.53 154.44 106.147 155.37 106.58C156.301 106.991 157.296 107.196 158.356 107.196C159.244 107.196 159.914 107.067 160.369 106.807C160.823 106.526 161.05 106.147 161.05 105.671C161.05 105.195 160.856 104.805 160.466 104.502C160.077 104.178 159.557 103.897 158.908 103.659C158.281 103.399 157.577 103.139 156.798 102.88C156.041 102.62 155.284 102.306 154.526 101.938C153.769 101.57 153.066 101.127 152.417 100.608C151.789 100.067 151.281 99.4066 150.891 98.6277C150.502 97.827 150.307 96.8533 150.307 95.7065C150.307 94.2135 150.664 92.926 151.378 91.8441C152.092 90.7622 153.098 89.94 154.397 89.3774C155.695 88.7931 157.22 88.501 158.973 88.501C160.704 88.501 162.305 88.7823 163.777 89.3449C165.27 89.8859 166.503 90.6648 167.477 91.6818L163.387 95.739C162.673 95.0465 161.959 94.5381 161.245 94.2135C160.531 93.8673 159.752 93.6942 158.908 93.6942C158.237 93.6942 157.696 93.8024 157.285 94.0187C156.896 94.2351 156.701 94.5597 156.701 94.9925C156.701 95.4469 156.896 95.8255 157.285 96.1285C157.675 96.4097 158.183 96.6694 158.811 96.9074C159.46 97.1454 160.163 97.3943 160.921 97.6539C161.7 97.9136 162.468 98.2273 163.225 98.5952C163.982 98.9414 164.675 99.3958 165.302 99.9584C165.951 100.499 166.471 101.181 166.86 102.003C167.25 102.825 167.444 103.821 167.444 104.989C167.444 107.348 166.601 109.176 164.913 110.475C163.247 111.751 160.888 112.389 157.837 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.238 112V88.8905H182.729V112H176.238ZM169.324 94.4082V88.8905H189.675V94.4082H169.324Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.919 112.454C202.101 112.454 200.424 112.151 198.888 111.546C197.373 110.94 196.043 110.096 194.896 109.014C193.771 107.932 192.894 106.655 192.267 105.184C191.639 103.713 191.326 102.122 191.326 100.413C191.326 98.6817 191.628 97.0913 192.234 95.6416C192.862 94.1918 193.738 92.926 194.863 91.8441C195.989 90.7622 197.308 89.9291 198.823 89.3449C200.359 88.739 202.036 88.4361 203.854 88.4361C205.672 88.4361 207.338 88.739 208.852 89.3449C210.389 89.9291 211.719 90.7622 212.845 91.8441C213.97 92.926 214.835 94.2027 215.441 95.6741C216.069 97.1238 216.382 98.7142 216.382 100.445C216.382 102.155 216.069 103.745 215.441 105.216C214.835 106.666 213.97 107.943 212.845 109.046C211.719 110.128 210.4 110.972 208.885 111.578C207.37 112.162 205.715 112.454 203.919 112.454ZM203.854 106.742C205.066 106.742 206.115 106.482 207.002 105.963C207.889 105.444 208.571 104.708 209.047 103.756C209.523 102.804 209.761 101.689 209.761 100.413C209.761 99.4607 209.621 98.606 209.339 97.8487C209.08 97.0697 208.69 96.4097 208.171 95.8688C207.651 95.3062 207.024 94.8843 206.288 94.603C205.574 94.3 204.763 94.1486 203.854 94.1486C202.642 94.1486 201.593 94.4082 200.706 94.9275C199.818 95.4252 199.137 96.1501 198.661 97.1022C198.185 98.0326 197.947 99.1361 197.947 100.413C197.947 101.387 198.077 102.263 198.336 103.042C198.618 103.821 199.018 104.492 199.537 105.054C200.056 105.595 200.673 106.017 201.387 106.32C202.123 106.601 202.945 106.742 203.854 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.354 112V88.8905H225.06L233.661 101.484H231.617L240.185 88.8905H244.891V112H238.465V99.5365L239.406 99.7961L234.7 106.547H230.545L225.872 99.7961L226.78 99.5365V112H220.354Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.492 112L269.517 88.8905H274.58L270.523 112H265.492ZM256.112 105.736V101.516H275.392V105.736H256.112ZM257.865 112L261.922 88.8905H266.92L262.928 112H257.865ZM257.281 98.8873V94.7003H276.528V98.8873H257.281Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.693 112.389C287.702 112.389 285.928 111.881 284.37 110.864C282.834 109.825 281.622 108.408 280.735 106.612C279.848 104.795 279.404 102.728 279.404 100.413C279.404 98.0975 279.837 96.0419 280.702 94.2459C281.59 92.45 282.801 91.0435 284.338 90.0265C285.874 89.0095 287.637 88.501 289.628 88.501C291.64 88.501 293.415 89.0095 294.951 90.0265C296.509 91.0435 297.721 92.45 298.586 94.2459C299.473 96.0419 299.917 98.1083 299.917 100.445C299.917 102.782 299.473 104.849 298.586 106.645C297.721 108.441 296.52 109.847 294.983 110.864C293.447 111.881 291.684 112.389 289.693 112.389ZM289.661 106.872C290.461 106.872 291.143 106.623 291.705 106.125C292.268 105.628 292.69 104.903 292.971 103.951C293.274 102.977 293.426 101.808 293.426 100.445C293.426 99.0821 293.274 97.9244 292.971 96.9723C292.69 96.0203 292.268 95.2954 291.705 94.7977C291.143 94.2784 290.45 94.0187 289.628 94.0187C288.849 94.0187 288.178 94.2676 287.616 94.7653C287.053 95.2629 286.62 95.9878 286.317 96.9399C286.036 97.892 285.895 99.0496 285.895 100.413C285.895 101.776 286.036 102.944 286.317 103.918C286.62 104.87 287.053 105.606 287.616 106.125C288.178 106.623 288.86 106.872 289.661 106.872Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock0);
export default __webpack_public_path__ + "static/media/custom-block-0.7a5d1c946cb3e5da4903abf1fa70d131.svg";
export { ForwardRef as ReactComponent };